<template>
<div>
  <div class="vx-row">

   

    <!-- MULTIPLE COLUMNS-->
    <div class="vx-col w-full mb-base">
      
      <vx-card title="">
        <div class="demo-alignment">
          
           
            
        </div>
      </vx-card>
      <vx-card title="">
        
      </vx-card>
    </div>


    <div class="vx-col lg:w-4/4 w-full relative">

  <vs-table :data="list" :hidden="validated">

    <template slot="thead">
      <vs-th  sort-key="stokkodu">Sipariş No</vs-th>
      <vs-th  sort-key="stokkodu">Fatura No</vs-th>
      <vs-th>Adı Soyadı</vs-th>
     
      <vs-th>Tutar</vs-th>
      <vs-th>Komisyon Tutarı</vs-th>
      <vs-th>Kargo Bedeli</vs-th>
      <vs-th>İşlem Durumu</vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

        <vs-td :data="data[indextr].siparisNo">
          {{ data[indextr].siparisNo }}
        </vs-td>
        <vs-td :data="data[indextr].faturaNo">
          {{ data[indextr].faturaNo }} 
        </vs-td>
        <vs-td :data="data[indextr].ad">
          {{ data[indextr].ad }}
        </vs-td>

        <vs-td :data="data[indextr].tutar">
           {{ data[indextr].tutar }} 
        </vs-td>
<vs-td :data="data[indextr].kargoBedeli">
           {{ data[indextr].kargoBedeli }} 
        </vs-td>
        <vs-td :data="data[indextr].komisyon">
           {{ data[indextr].komisyon }} 
        </vs-td>
        <vs-td :data="data[indextr].islemDurumu">
           <span v-if="data[indextr].islemDurumu == '1'">
                      <vs-button color="success" type="filled">Ödeme Tamam</vs-button>
                        </span>
                         <span v-if="data[indextr].islemDurumu == '0'">
                      <vs-button color="red" type="filled">Ödeme Bekleniyor</vs-button>
                        </span>
          
        </vs-td>
       
       
      </vs-tr>
      <vs-td colspan="4" style="text-align:right">Toplam : </vs-td>
      <vs-td>{{toplamParca}} Parça</vs-td>
      <vs-tr>

      </vs-tr>
    </template>

  </vs-table>


<div class="con-pagination-table vs-table--pagination">
  <div class="vs-row" style="justify-content: space-between; display: flex; width: 100%;">
    <div class="vs-col vs-pagination--mb vs-xs-12 vs-sm-12 vs-lg-6" style="justify-content: flex-start; display: flex; align-items: center; margin-left: 0%; width: 100%;">
      </div>
      <div class="vs-col vs-pagination--mb vs-xs-12 vs-sm-12 vs-lg-6" style="justify-content: flex-end; display: flex; align-items: center; margin-left: 0%; width: 100%;">
        <div class="con-vs-pagination vs-pagination-primary">
          <nav class="vs-pagination--nav">
            <button class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev" @click="sayfaGeri();">
              <i class="vs-icon notranslate icon-scale material-icons null">chevron_left</i>
              </button>
              <ul class="vs-pagination--ul">
                
              </ul>
                <button class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" @click="sayfaIleri();">
                  <i class="vs-icon notranslate icon-scale material-icons null">chevron_right</i>
                  </button>
                  <!---->
                  </nav>
                  </div>
                  </div>
                  </div>
                  </div>

</div>

</div>
    


     
<vs-prompt title="Partileme İşlemleri" acceptText="İşlemi Başlat" cancelText="Vazgeç"
      @accept="partilemeyiBaslat"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Partileme Miktarı</span>
      <vs-input type="number" placeholder="Sayı Giriniz" vs-placeholder="Code" v-model="partiVal" class="mt-3 w-full" />
      </div>
    </vs-prompt>
          
           
    </div>


    
</template>



<script>
import state from '../../store/state'
import Store from '../../store/store'
export default {
  data () {
    return {
  listEksik: [],
  list:[
    {siparisNo:'456789120',faturaNo:'INT0023336601',ad:'Serkan Özbek',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789121',faturaNo:'INT0023336602',ad:'Sadık Önal',tutar:'126.00',islemDurumu:'0',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789122',faturaNo:'INT0023336603',ad:'Üzeyir Ekinci',tutar:'127.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789123',faturaNo:'INT0023336604',ad:'Murat Ay',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789124',faturaNo:'INT0023336605',ad:'Tuncay Tunç',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789125',faturaNo:'INT0023336606',ad:'Elmas Bakır',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789126',faturaNo:'INT0023336607',ad:'Ayşe Almaz',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789127',faturaNo:'INT0023336608',ad:'Ali Akça',tutar:'125.00',islemDurumu:'0',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789128',faturaNo:'INT0023336609',ad:'Levent Uçan',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789129',faturaNo:'INT0023336610',ad:'Fikri Uyarıcı',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789131',faturaNo:'INT0023336611',ad:'Serkan Özbek',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789132',faturaNo:'INT0023336612',ad:'Serkan Özbek',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789133',faturaNo:'INT0023336613',ad:'Serkan Özbek',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789134',faturaNo:'INT0023336614',ad:'Serkan Özbek',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789135',faturaNo:'INT0023336615',ad:'Serkan Özbek',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789136',faturaNo:'INT0023336616',ad:'Serkan Özbek',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789137',faturaNo:'INT0023336617',ad:'Serkan Özbek',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789138',faturaNo:'INT0023336618',ad:'Serkan Özbek',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
    {siparisNo:'456789139',faturaNo:'INT0023336619',ad:'Serkan Özbek',tutar:'125.00',islemDurumu:'1',kargoBedeli:'12',komisyon:'12.5'},
   
    ],
  progress:0,
  sayfaListe:0,
  toplamSayfa:0,
  activePrompt:false,
  partiVal:'',
  toplamParca:0,
  backgroundLoading:'danger',
  colorLoading:'#fff',
  siparisKaydetSayi:0,
  validated:false,
  validated1:true,
  siparisKontrolBasildimi:0,
  islemTipi:Store.state.islemTipi
    }
  },methods: {
   siparisCek(sayfasayisi) {
      var vs = this.$vs
     vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-yeni",
        scale: 0.45
      })


      var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Trendyol',siparisDurumu:0,listelenecekSayfa:sayfasayisi,token:Store.state.tokenId}
      soap.createClient(url, function(err, client){
      client.pazaryeriSiparisCek(args, function(err, result){
        if (result.pazaryeriSiparisCekResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.veriler=JSON.parse(result.pazaryeriSiparisCekResult)
      if (vm.veriler.response=='Ok') {
        if (parseInt(vm.veriler.page)<parseInt(vm.veriler.totalPages)) {
          vm.veriler.page=parseInt(vm.veriler.page)+1
          const percent=100/parseInt(vm.veriler.totalPages)
          vm.progress=percent*vm.veriler.page;
          vm.siparisCek(vm.veriler.page)
        } else {
          vs.loading.close("#button-with-loading-yeni > .con-vs-loading")
           vs.notify({
            title: 'Trendyol',
            text: "Siparişler Çekildi",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position:'top-center'
          })
        }
      } else {
        alert('Veriler Çekilemedi');
      }
      })
      })

   },
   sayfaIleri() {
     this.sayfaListe=this.sayfaListe+1;
     if (this.sayfaListe>this.toplamSayfa) {
       this.sayfaListe=this.toplamSayfa;
     }
     this.siparisListesi();
   },
   sayfaGeri() {
     this.sayfaListe=this.sayfaListe-1;
      if (this.sayfaListe<0) {
        this.sayfaListe=0;
      }
     this.siparisListesi();
   },
   siparisListesi() {
     this.validated1=true
     this.validated=false
     var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Trendyol',token:Store.state.tokenId,sayfa:vm.sayfaListe}
      soap.createClient(url, function(err, client){
      client.siparisListele(args, function(err, result){
        if (result.siparisListeleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.veriler=JSON.parse(result.siparisListeleResult)
      vm.toplamSayfa=vm.veriler[0]["toplamKayitSayisi"];
      vm.list=vm.veriler
      })
      })


   },
   kalanSiparisListesi() {
    this.validated1=false
     this.validated=true
     var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Trendyol',token:Store.state.tokenId}
      soap.createClient(url, function(err, client){
      client.kalanSiparisListesi(args, function(err, result){
        if (result.siparisListeleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.veriler=JSON.parse(result.kalanSiparisListesiResult)
      vm.listEksik=vm.veriler
      })
      })


   },
   partilemeyiBaslat() {
      const vm = this
      var vs=this.$vs
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {pazaryeri: 'Trendyol',parti:this.partiVal,token:Store.state.tokenId}

      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-partile",
        scale: 0.45
      })


      soap.createClient(url, function(err, client){
      client.partile(args, function(err, result){
        if (result.partileResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }

      vm.veriler=JSON.parse(result.partileResult)
        if (vm.veriler.response=='Ok') {
          vs.loading.close("#button-with-loading-partile > .con-vs-loading")
          vs.notify({
            title: 'Partileme',
            text: "Partileme İşlemi Başarılı",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position:'top-center'
          })

        } else {
          vs.notify({
            title: 'Partileme',
            text: "Partilemede Hata Oluştu",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'error',
            position:'top-center'
          })
        }
      })
      })
     
   },
   siparisKaydet() {
     var vs = this.$vs
     if (this.siparisKontrolBasildimi==1) {
     vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      })


     var vm = this
      
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {program: 'Trendyol',sayfa:this.siparisKaydetSayi,token:Store.state.tokenId,EMPLOYEEID:Store.state.plasiyer}
      soap.createClient(url, function(err, client){
      client.siparisKaydet(args, function(err, result){
        if (result.siparisKaydetResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.veriler=JSON.parse(result.siparisKaydetResult)
      //console.log(vm.veriler)
      if (vm.veriler.response=='Ok') {
        vm.siparisKaydetSayi=parseInt(vm.siparisKaydetSayi)+500;
        alert(vm.siparisKaydetSayi)
        vm.siparisKaydet()
      }
      if (vm.veriler.response=='Bitti') {
         vs.loading.close("#button-with-loading > .con-vs-loading")
         vm.siparisKontrol()
      }
     
      })
      })
      
       } else {
         vs.notify({
            title: 'Sipariş Kayıt',
            text: "Siparişi Kaydetmeden Önce Sipariş Kontrol Butonuna Basınız",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
      }
   },
   siparisKontrol() {
     this.siparisKontrolBasildimi=1
    this.validated1=true
     this.validated=false
     const vm = this
var vs = this.$vs
     vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading-control",
        scale: 0.45
      })

     const soap = require('soap')
      const url = state.sistemAddress
      const args = {program: 'Trendyol',token:Store.state.tokenId}
      soap.createClient(url, function(err, client){
      client.siparisKontrol(args, function(err, result){
        if (result.siparisKontrolResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        }
      vm.veriler=JSON.parse(result.siparisKontrolResult)
      vm.list=vm.veriler
     
         vs.loading.close("#button-with-loading-control > .con-vs-loading")
       })
      })
   },
   
  },
  watch: {
    list: {
      handler: function () {
       
        //this.toplamParca=this.list.reduce((acc, item) => Number(acc) + (Number(item.siparisAdetleri)), 0)
        this.toplamParca=this.list.reduce((sum, item) => sum + item.siparisAdetleri, 0);
      },
      deep: true
    }
  }
  
}

</script>
<style lang="scss" scoped>
.mb-base { margin-bottom: 0.75rem!important;}
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
